/*
 * @Author: CYX
 * @Date: 2020-05-12 11:44:46
 * @LastEditors: CYX
 * @LastEditTime: 2020-07-09 18:09:58
 */ 
export const expertConsultationChatCn = {
    zxyjs:"咨询已结束",
    yjs:"已结束",
    fanhui:"返回",
    pingjia:"评价",
    fasong:"发送",
    shengyuzxsj:"剩余咨询时间",
    tishi:"很高兴为您服务？请描述您的问题。"
}


// WEBPACK FOOTER //
// ./src/lang/home/expertConsultationChat/indexCn.js